module.exports = __webpack_public_path__ + "static/img/jdcy.0647c6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jdcy.png
// module id = ridj
// module chunks = 0